module.exports = __webpack_public_path__ + "static/img/d-overview.1f3b9a93.png";